import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionDescription: {
    id: 'Section Description',
    defaultMessage: 'Section Description',
  },
  description: { id: 'Description', defaultMessage: 'Description' },
  textFiedDescription: {
    id: 'textFiedDescription',
    defaultMessage: 'Enter the text that will be displayed in the block.',
  },
});

export const sectionDescriptionSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.sectionDescription),
        fields: ['description'],
      },
    ],
    properties: {
      description: {
        title: intl.formatMessage(messages.description),
        description: intl.formatMessage(messages.textFiedDescription),
      },
    },
    required: ['description'],
  };
};
